import { useEffect } from 'react';

/**
 * La moitié « interface » du plein écran : **un attribut sur le `body`, rien d'autre**. Cinq
 * règles CSS (`desk.css`, § « Plein écran ») font ensuite disparaître la barre de menu et le dock,
 * retirent les marges du bureau, et étalent la fenêtre.
 *
 * L'autre moitié — celle qui fait disparaître la barre d'adresse et les onglets du navigateur —
 * est `useBrowserFullscreen`, et c'est **elle** qui commande : `active` vaut ce que le document
 * répond, jamais ce que le bureau a demandé. Cet attribut suit, il ne décide pas.
 *
 * Le nettoyage compte autant que la pose : une fenêtre démontée en plein écran (fermeture,
 * navigation, session expirée) doit **retirer** l'attribut, sans quoi le bureau resterait sans
 * barre de menu ni dock, sans rien pour les faire revenir.
 */
export function useBodyFullscreen(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    document.body.setAttribute('data-fs', 'true');
    return () => {
      document.body.removeAttribute('data-fs');
    };
  }, [active]);
}
